export const LISTE_UTILISATEURS = "LISTE_UTILISATEURS";
export const GENERER_ATTESTATION = "GENERER_ATTESTATION";
export const AJOUTER_ALERTE_SUCCES = "AJOUTER_ALERTE_SUCCES";
export const SUPPRIMER_ALERTE_SUCCES = "SUPPRIMER_ALERTE_SUCCES";
